import { canonicalizePhone } from "@orbit/api-zod";

export { canonicalizePhone };

/** Format a canonical or partial PH mobile number for display: 0917-123-4567 */
export function formatPhDisplay(input: string): string {
  const digits = input.replace(/\D+/gu, "");
  if (digits.length === 0) return "";
  // Try to convert to local 09XXXXXXXXX style for display
  let local = digits;
  if (local.startsWith("63")) local = "0" + local.slice(2);
  if (!local.startsWith("0") && local.length === 10) local = "0" + local;
  if (local.length > 11) local = local.slice(0, 11);
  if (local.length <= 4) return local;
  if (local.length <= 7) return `${local.slice(0, 4)}-${local.slice(4)}`;
  return `${local.slice(0, 4)}-${local.slice(4, 7)}-${local.slice(7)}`;
}
